import { useTheme } from '../../hooks';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var Declined = () => {
  var {
    colors
  } = useTheme();
  return /*#__PURE__*/_jsxs("svg", {
    height: "100%",
    viewBox: "0 0 144 144",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [/*#__PURE__*/_jsx("path", {
      d: "M126 72C126 101.823 101.823 126 72 126C42.1766 126 18 101.823 18 72C18 42.1766 42.1766 18 72 18C101.823 18 126 42.1766 126 72Z",
      fill: colors.illustration.critical
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M72 122C99.6142 122 122 99.6142 122 72C122 44.3858 99.6142 22 72 22C44.3858 22 22 44.3858 22 72C22 99.6142 44.3858 122 72 122ZM72 126C101.823 126 126 101.823 126 72C126 42.1766 101.823 18 72 18C42.1766 18 18 42.1766 18 72C18 101.823 42.1766 126 72 126Z",
      fill: colors.illustration.stroke
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M70.7578 80.2521C71.5388 79.4711 72.8052 79.4711 73.5862 80.2521L94.0908 100.757C94.8718 101.538 96.1382 101.538 96.9192 100.757L100.757 96.9188C101.538 96.1377 101.538 94.8714 100.757 94.0904L80.2525 73.5858C79.4715 72.8047 79.4715 71.5384 80.2525 70.7574L100.758 50.2521C101.539 49.4711 101.539 48.2047 100.758 47.4237L96.9199 43.5858C96.1388 42.8047 94.8725 42.8047 94.0915 43.5858L73.5862 64.091C72.8052 64.8721 71.5388 64.8721 70.7578 64.091L50.2525 43.5858C49.4715 42.8047 48.2052 42.8047 47.4241 43.5858L43.5862 47.4237C42.8052 48.2047 42.8052 49.4711 43.5862 50.2521L64.0915 70.7574C64.8725 71.5384 64.8725 72.8047 64.0915 73.5858L43.5869 94.0904C42.8058 94.8714 42.8058 96.1377 43.5869 96.9188L47.4248 100.757C48.2058 101.538 49.4722 101.538 50.2532 100.757L70.7578 80.2521Z",
      fill: colors.illustration.bg
    })]
  });
};
//# sourceMappingURL=Declined.js.map